module.exports = __webpack_public_path__ + "static/media/sports.ad55cce6.svg";